/* eslint-disable */
import request from './helpers'

export function accessToken (token) {
  return request({
    url: '/backend/accessToken',
    method: 'post',
    params: {
      token
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function awsLogin (data) {
  return request({
    url: '/backend/common/awsAccess',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function listNamespace () {
  return request({
    url: '/backend/common/namespace',
    method: 'get'
  })
}

export function listApplication (namespace, applicationName, menuFullPath) {
  return request({
    url: '/backend/application/list',
    method: 'get',
    params: {
      namespace, applicationName, menuFullPath
    }
  })
}

export function deleteApp (applicationId) {
  return request({
    url: '/backend/application/unregister',
    method: 'delete',
    data: {
      applicationId
    }
  })
}

export function getAppById (applicationId) {
  return request({
    url: '/backend/application/getById',
    method: 'get',
    params: {
      applicationId
    }
  })
}

export function generateBackup (applicationId) {
  return request({
    url: '/backend/application/generateBackup',
    method: 'post',
    params: {
      applicationId
    }
  })
}

export function createApplication (data) {
  return request({
    url: '/backend/application/register',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function generateJwtToken (data) {
  return request({
    url: '/backend/application/generateJwtToken',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function initCmk (applicationId) {
  return request({
    url: '/backend/application/initCmk',
    method: 'post',
    params: {
      applicationId
    }
  })
}

export function listCmk (params) {
  return request({
    url: '/backend/application/cmk/pageList',
    method: 'get',
    params
  })
}

export function saveCmk (data) {
  return request({
    url: '/backend/application/cmk',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function deleteCmk (id, applicationId) {
  return request({
    url: '/backend/application/cmk',
    method: 'delete',
    params: {
      id, applicationId
    }
  })
}

export function listPath (params) {
  return request({
    url: '/backend/common/path',
    method: 'get',
    params
  })
}

export function listAllPath (params) {
  return request({
    url: '/backend/common/allPath',
    method: 'get',
    params
  })
}

export function listTreePath (params) {
  return request({
    url: '/backend/policy/treePath',
    method: 'get',
    params
  })
}

export function listType () {
  return request({
    url: '/backend/common/keyType',
    method: 'get'
  })
}

export function getSecretList (params) {
  return request({
    url: '/backend/secret/pageList',
    method: 'get',
    params
  })
}

export function getShareKeyList (params) {
  return request({
    url: '/backend/secret/shareKeyPageList',
    method: 'get',
    params
  })
}

export function createSecret (data) {
  return request({
    url: '/backend/secret/save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function forceUpdateSecret (data) {
  return request({
    url: '/backend/secret/forceUpdate',
    method: 'put',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function deleteSecret (ids) {
  return request({
    url: '/backend/secret/delete',
    method: 'delete',
    data: {
      ids
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getSecret (id) {
  return request({
    url: '/backend/secret/getValue',
    method: 'get',
    params: {
      id
    }
  })
}

export function previewPolicy (params) {
  return request({
    url: '/backend/policy/preview',
    method: 'get',
    params
  })
}

export function attachPolicy (data) {
  return request({
    url: '/backend/policy/attach',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function deletePolicy (pathId, deleteRoleOnly) {
  return request({
    url: '/backend/policy/delete',
    method: 'delete',
    params: {
      pathId,
      deleteRoleOnly
    }
  })
}

export function createRole (data) {
  return request({
    url: '/backend/policy/createRole',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function downloadTemplate (fileSuffix) {
  return request({
    url: '/backend/secret/template',
    method: 'get',
    params: {
      fileSuffix
    }
  })
}

export function downloadUpdateTemplate (action) {
  return request({
    url: '/backend/secret/downloadBatchUpdateTemplate',
    method: 'get',
    params: {
      action
    }
  })
}

export function listInstance (params) {
  return request({
    url: '/backend/instance/pageList',
    method: 'get',
    params
  })
}

export function retryInstance (data) {
  return request({
    url: '/backend/instance/retry',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function checkInstance (data) {
  return request({
    url: '/backend/instance/check',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function unregisterInstance (data) {
  return request({
    url: '/backend/instance/unregister',
    method: 'delete',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getExtendList (params) {
  return request({
    url: '/backend/extend/policy/pageList',
    method: 'get',
    params
  })
}

export function deleteExtend (policyId) {
  return request({
    url: '/backend/extend/policy/delete',
    method: 'delete',
    params: {
      policyId
    }
  })
}

export function createExtend (data) {
  return request({
    url: '/backend/extend/policy/save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getExtend (policyId) {
  return request({
    url: '/backend/extend/policy/preview',
    method: 'get',
    params: {
      policyId
    }
  })
}

export function queryExtend (arnID) {
  return request({
    url: '/backend/extend/policy/query',
    method: 'get',
    params: {
      arnID
    }
  })
}

export function bindExtend (data) {
  return request({
    url: '/backend/extend/policy/bind',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function detachExtend (policyId) {
  return request({
    url: '/backend/extend/policy/detachRole',
    method: 'delete',
    params: {
      policyId
    }
  })
}

export function dashboard () {
  return request({
    url: '/backend/dashboard',
    method: 'get'
  })
}

export function hashSecret (data) {
  return request({
    url: '/backend/secret/hashSecret',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function duplicateSecret (data) {
  return request({
    url: '/backend/secret/duplicate',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getSameSecretStatistics (params) {
  return request({
    url: '/backend/secret/sameSecretStatistics',
    method: 'get',
    params
  })
}

export function getSameSecretStatisticsByPie (secretHashValue) {
  return request({
    url: '/backend/secret/sameSecretStatisticsByPie',
    method: 'get',
    params: {
      secretHashValue
    }
  })
}

export function downloadMetadata (prefixPath) {
  return request({
    url: '/backend/secret/metadataDownload',
    method: 'get',
    params: {
      prefixPath
    }
  })
}

export function listBaseInfo () {
  return request({
    url: '/backend/application/listBaseInfo',
    method: 'get'
  })
}

export function secretShareRangePageList (params) {
  return request({
    url: '/backend/secret/secretShareRangePageList',
    method: 'get',
    params
  })
}

export function verifySecretVersion (params) {
  return request({
    url: '/backend/secret/verifySecretVersion',
    method: 'get',
    params
  })
}
